import { render, staticRenderFns } from "./base-button-icon.vue?vue&type=template&id=6e8f2e57&scoped=true&"
import script from "./base-button-icon.vue?vue&type=script&lang=js&"
export * from "./base-button-icon.vue?vue&type=script&lang=js&"
import style0 from "./base-button-icon.vue?vue&type=style&index=0&id=6e8f2e57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8f2e57",
  null
  
)

export default component.exports